import {deviceEnquire, DEVICE_TYPE} from '../util/deviceType'
import {isMenuCollapse} from '../util/isMenuCollapse'

export default {
    data() {
        return {
            device: '',
            isCollapse: false,
            entityCol: ''
        }
    },
    mounted() {
        deviceEnquire(deviceType => {
            this.device = deviceType;
            switch (deviceType) {
                case DEVICE_TYPE.DESKTOP:
                    this.isCollapse = isMenuCollapse.getIsMenuCollapse();
                    this.entityCol = '';
                    break;
                case DEVICE_TYPE.TABLET:
                    this.isCollapse = true;
                    this.entityCol = '50%';
                    break;
                case DEVICE_TYPE.MOBILE:
                default:
                    this.isCollapse = false;
                    this.entityCol = '100%';
                    break
            }
        })
    },
    computed: {
        isMobile() {
            return this.device === DEVICE_TYPE.MOBILE
        },
        isDesktop() {
            return this.device === DEVICE_TYPE.DESKTOP
        },
        isTablet() {
            return this.device === DEVICE_TYPE.TABLET
        }
    }
}




// WEBPACK FOOTER //
// ./src/mixins/device.js